<template>
    <div>
        <div class="fw-semibold">{{ review.reviewerName || 'StayMarquis Guest' }}</div>
        <div class="d-flex align-items-center">
            <span v-if="reviewedOn" class="me-3">{{ reviewedOn }}</span>
            <form-stars-rating :value="review.rating" :readonly="true" onColor="primary" class="x-small" />
        </div>
    </div>

</template>

<script type="text/javascript">
    import CommonComponents from '@/components/Common.vue';

    import ApiObject from '@/classes/ApiObject.js';
    import DateObject from '@/classes/DateObject.js';
    import Formatter from '@/classes/Formatter.js';

    export default {

        components: {
            ...CommonComponents,
        },


        props: {
            review: {
                type: ApiObject,
                required: true,
            },
        },

        computed: {

            reviewedOn() {
                if ((this.review) && (this.review.reviewDate)) {
                    let now = new DateObject();
                    let years = now.diffInYears(this.review.reviewDate);
                    if (years > 0) {
                        return years+' '+Formatter.pluralize(years, 'years', 'year')+' ago';
                    }
                    let months = now.diffInMonths(this.review.reviewDate);
                    if (months > 0) {
                        return months+' '+Formatter.pluralize(months, 'months', 'month')+' ago';
                    }
                    let days = now.diffInDays(this.review.reviewDate);
                    if (days > 0) {
                        return days+' '+Formatter.pluralize(days, 'days', 'day')+' ago';
                    }
                    return 'today';
                }
                return null;
            },

        },
    };

</script>
